import React from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowRight, MessageSquare } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { canAccess, FEATURE_MIN_PLAN, PLAN_LABELS, ADVISOR_MAILTO } from "@/lib/plans";

const NEED_LABEL = {
  explorer: "a TWIN plan",
  growth: "TWIN Growth/Professional",
  professional: "TWIN Professional",
};

export default function PlanGate({ feature, module, title, compact = false, children }) {
  const { user } = useAuth();
  const key = feature || module;
  if (canAccess(user, key)) return children;
  const need = FEATURE_MIN_PLAN[key];
  const ended = (user?.plan_info?.effective_plan || "none") === "none";
  const wasTrial = user?.plan_info?.trial || !user?.plan_info?.source;
  const heading = ended ? (wasTrial ? "Your free trial has ended" : "Your plan has ended") : `Upgrade to ${NEED_LABEL[need]}`;
  const body = ended
    ? "Choose a plan to unlock your tenders and modules again. All your data is kept safe."
    : `${title} is included with ${PLAN_LABELS[need]}${need !== "professional" ? " and higher plans" : ""}. You're currently on ${user?.plan_info?.label || PLAN_LABELS.none}.`;
  return (
    <div className={`${compact ? "mt-6" : "max-w-2xl mx-auto mt-16"} card-flat p-10 text-center`} data-testid={`plan-gate-${key}`}>
      <div className="w-14 h-14 mx-auto bg-brand-soft text-brand grid place-items-center rounded-sm">
        <Lock className="w-6 h-6" />
      </div>
      <div className="text-[11px] uppercase tracking-[0.2em] text-ink-muted mt-6">{title}</div>
      <h1 className="font-display text-3xl font-bold tracking-tight mt-2" data-testid="plan-gate-title">{heading}</h1>
      <p className="text-sm text-ink-muted mt-3 leading-relaxed max-w-lg mx-auto">{body}</p>
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <Link to={`/plans?plan=${ended ? "explorer" : need}`} data-testid="plan-gate-upgrade-btn" className="inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white text-sm font-medium px-5 py-2.5 rounded-sm transition-colors">
          {ended ? "Choose a plan" : "View plans & upgrade"} <ArrowRight className="w-4 h-4" />
        </Link>
        <a href={ADVISOR_MAILTO} data-testid="plan-gate-advisor-btn" className="inline-flex items-center gap-2 border border-ink-line hover:bg-secondary text-sm font-medium px-5 py-2.5 rounded-sm transition-colors">
          <MessageSquare className="w-4 h-4" /> Talk to an Advisor
        </a>
      </div>
    </div>
  );
}
